import { required, optional } from 'AppReact/schema';

export const tableOrder = {
  assigned_at: optional('jsDate'),
  cancelation_reason: optional('string'),
  cancelled_at: optional('jsDate'),
  cancelled_by: optional('string'),
  category_name: required('string'),
  category_id: required('integer'),
  comment_count: optional('integer'),
  completed_at: optional('jsDate'),
  category_id: required('integer'),
  id: required('integer'),
  inserted_at: optional('jsDate'),
  last_comment: optional('string'),
  level: required('string'),
  parent_category_name: required('string'),
  property_id: required('integer'),
  property_name: required('string'),
  rating: optional('integer'),
  request_id: required('integer'),
  status: required('string'),
  tech_id: optional('integer'),
  tech_image: optional('string'),
  tech_name: optional('string'),
  tenancy_id: optional('integer'),
  tenant_name: optional('string'),
  unit_id: optional('integer'),
  unit_number: optional('string'),
  vendor_id: optional('integer'),
  vendor_name: optional('string'),
  vendor_url: optional('string')
}